@if (mainFilename$ | async; as mainFilename) {
  <unf-angebot
    *axLazyElement="'unf-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></unf-angebot>
}
